@if (windowScrolled) {
  <div
    class="scroll-to-top"
    [ngClass]="{ 'show-scrollTop': windowScrolled }"
    >
    <button (click)="scrollToTop()" data-test="tx-back-to-top-scroll-to-top-button">
      <fa-icon [icon]="arrowUp" size="2x"></fa-icon>
    </button>
  </div>
}
